export default {
    eventBusNameMap: {
        phaserGame: {
            //Constants.eventBusNameMap.phaserGame.GAME_FINISH_INIT
            GAME_FINISH_INIT: "phaserGame.GAME_FINISH_INIT",
        },
        UI: {
            //Constants.eventBusNameMap.UI.REPOSITION_GAME_UI
            REPOSITION_GAME_UI: "UI.REPOSITION_UI",
            //Constants.eventBusNameMap.UI.REQUEST_RESIZE_WINDOW
            REQUEST_RESIZE_WINDOW: "UI.REQUEST_RESIZE_WINDOW",
            //Constants.eventBusNameMap.UI.COMMAND_DIALOGUE
            COMMAND_DIALOGUE: "UI.COMMAND_DIALOGUE"
        },
        connection: {
            //Constants.eventBusNameMap.connection.UPDATE_PLAYER_INFO
            UPDATE_PLAYER_INFO: "connection.UPDATE_PLAYER_INFO",
            //Constants.eventBusNameMap.connection.UPDATE_OTHER_PLAYER_INFO
            UPDATE_OTHER_PLAYER_INFO: "connection.UPDATE_OTHER_PLAYER_INFO",
        },
        auth: {
            //Constants.eventBusNameMap.auth.LOGGED_IN
            LOGGED_IN: "auth.LOGGED_IN",
            //Constants.eventBusNameMap.auth.LOGGED_OUT
            LOGGED_OUT: "auth.LOGGED_OUT",
        },
        appState: {
            //Constants.eventBusNameMap.appState.APP_STATE_UPDATED
            APP_STATE_UPDATED: "appState.APP_STATE_UPDATED"
        }
    },
    UITypeMap: {
        DIALOGUE_BOX: "DIALOGUE_BOX",
    },
    backendMessageTypeMap: {
        MessageType_SERVER_INFO:        0,
        MessageType_CONNECTION_INFO:    1,
        MessageType_CLIENT_INFO:        2,
        MessageType_CLIENT_REQUEST:     3,
        MessageType_CLIENT_RESPONSE:    4,
        MessageType_AVATAR_INFO:        5,
        MessageType_MMOROOM_INFO:       6,
    },
    appState: {
        AppState_NONE:                  -1,
        AppState_AUTH:                  0,
        AppState_SELECT_SCHOOL:         1,
        AppState_AVATAR_CONFIG:         2,
        AppState_GAMEPLAY:              3,
    },
    schoolType: {
        SchoolType_AGRI:                0,
        SchoolType_TECH:                1,
        SchoolType_BIZ:                 2,
    },
    pageIndexMap: {
        title:              1,
        howToPlay:          2,
        characterCreator:   3,
        characterProfile:   4,
        gameplay:           5,
        summary:            6,
        result:             7,
    },
}